import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialYatay01Component } from './social-yatay01.component';
@NgModule({
  declarations: [SocialYatay01Component],
  imports: [
    CommonModule,
  ],
  exports:[SocialYatay01Component
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class SocialYatay01Module { }
